import type { Dispatch, FC, SetStateAction } from "react";

import { Box, Stack, Typography } from "@mui/material";

import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useEditCampaign } from "../../../context/EditCampaignContext";

type Forms = "classic" | "small" | "compact";

interface BrandingNotificationSizeProps {
  setActive: Dispatch<SetStateAction<Forms>>;
  activeSize: Forms;
}

export const BrandingNotificationSize: FC<BrandingNotificationSizeProps> = ({
  setActive: onActive,
  activeSize,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { setDetectedChange } = useEditCampaign();

  const [active, setActive] = useState<Forms>(activeSize);

  useEffect(() => {
    if (onActive) {
      onActive(active);
    }
  }, [active]);

  useEffect(() => {
    if (active !== activeSize) {
      setDetectedChange(true);
    }
  }, [active]);

  useEffect(() => {
    setActive(activeSize);
  }, [activeSize]);

  return (
    <Stack direction='row'>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => setActive("classic")}
      >
        <div
          style={{
            height: "100px",
            width: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <div
            style={{
              width: "90%",
              height: "90%",
              transition: "all 0.3s",
              border: `3px solid ${
                active === "classic"
                  ? theme.palette.main.primary.o
                  : theme.palette.natural.t3
              }`,
              backgroundColor: active === "classic" ? "#FFF9F1" : "#FFFFFF",
            }}
          />
        </div>
        <Typography>{t("campaign.branding.sizeAndForm.classic")}</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => setActive("small")}
      >
        <div
          style={{
            height: "100px",
            width: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <div
            style={{
              width: "90%",
              height: "60%",
              transition: "all 0.3s",
              border: `3px solid ${
                active === "small"
                  ? theme.palette.main.primary.o
                  : theme.palette.natural.t3
              }`,
              backgroundColor: active === "small" ? "#FFF9F1" : "#FFFFFF",
            }}
          />
        </div>
        <Typography>{t("campaign.branding.sizeAndForm.small")}</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => setActive("compact")}
      >
        <div
          style={{
            height: "100px",
            width: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <div
            style={{
              width: "70%",
              height: "90%",
              transition: "all 0.3s",
              border: `3px solid ${
                active === "compact"
                  ? theme.palette.main.primary.o
                  : theme.palette.natural.t3
              }`,
              backgroundColor: active === "compact" ? "#FFF9F1" : "#FFFFFF",
            }}
          />
        </div>
        <Typography>{t("campaign.branding.sizeAndForm.compact")}</Typography>
      </Box>
    </Stack>
  );
};
